<template>
    <nav id="navigation" ref="navNode" :class="currentPage">

        <div class="nav-bg" ref="bgNode" @click="onCloseMenu"></div>

        <div class="nav-close" ref="closeNode" @click="onCloseMenu">
            <div class="label">
                <p>
                    {{this.navCloseText}}
                </p>
            </div>

            <div class="close-btn">
                <span class="bar-1"></span>
                <span class="bar-2"></span>
            </div>
        </div>


        <ul id="primary-menu" ref="menuNode">
            
            <!-- Router Slot - https://router.vuejs.org/api/#v-slot-api-3-1-0 -->
            <router-link
                v-for="(nav, index) in navigation" :key="index" 
                v-slot="{ href, route, navigate, isActive, isExactActive }"
                :to="nav.url"
                :exact="(nav.url === '/')" 
            >
                <li 
                    class="nav-item"
                    :class="[isActive && 'active', isExactActive && 'exact-active']"
                    @mouseover="onMouseOver(index)"
                    @mouseleave="onMouseLeave(index)"
                    
                >
                    <span @click.capture="onMouseClick(index, $event)">
                        <a v-if="isInternalLink(nav.url)" class="nav-link" :href="href" @click="navigate">{{nav.name}}</a>
                        <a v-else class="nav-link" :href="nav.url" target="_blank">{{nav.name}}</a>
                        
                    </span>
                </li>
            </router-link>
        </ul>
        
        <div class="burger" ref="burger">
            <span class="bar-1" ref="burgerBar1"></span>
            <span class="bar-2" ref="burgerBar2"></span>
        </div>
        <div v-if="!isActive" class="hit-area" ref="hitArea" @mouseover="onPopOut()" @mouseleave="onPopIn()" @click="onShow()"></div>
        
    </nav>
</template>

<script>
import { TimelineLite } from 'gsap/all'
import Size from '@/plugins/WindowSize'

export default {
    
    components: {},
    
    data: function() {
        return {
            isActive: false,
            textColor: null,
            navItems: [],
            navCloseText: 'Close menu',
            activeId: 0,
            peek: 0,
            hoverPeek: 8,
            margin: 0,
            fontsLoaded: false,
            showCloseBn: false,
            currentPage: '',

            navigation: [{
                    name: 'e-Types',
                    url: '/',
                    textColor: '#fff'
                },
                {
                    name: 'Work',
                    url: '/work/',
                    textColor: '#000'
                },
                {
                    name: 'Profile',
                    url: '/profile/',
                    textColor: '#000'
                },
                {
                    name: 'Playtype',
                    url: 'http://playtype.com',
                },
                {
                    name: 'Studio 6',
                    url: 'http://google.com',
                },
                {
                    name: 'Contact us',
                    url: '/contact/',
                    textColor: '#000'
                },
            ]
        }
    },
    
    created() {
        Size.addListener(this.onResize)
    },
    
    destroyed() {
        Size.removeListener(this.onResize)
    },
    
    mounted() {

        this.navItems = document.querySelectorAll('.nav-item')
        this.margin = Size.width*0.06

        // Set navigation nodes
        for (var i = 0; i < this.navigation.length; i++) {
            let nav = this.navigation[i]
            let li = this.navItems[i]
            let span = li.querySelector('span')
            nav.node = li
            nav.span = span
        }
        
        // How much should the navigation "peek" (hidden on mobile)
        this.peek = (Size.width < 1024) ? -10 : 32
        
        this.calculateNavSizes()
        this.setActiveNavItem()
        
        
        // Initial animation - Show menu + Hide menu (unless frontpage)
        this.setShow(false)
        TweenLite.set(this.$refs.hitArea, {autoAlpha:0})
        TweenLite.set(this.$refs.hitArea, {delay: 1.2, autoAlpha:1})
        TweenLite.set(this.$refs.burger, {autoAlpha:0})
        
        // TweenLite.set(this.$refs.menuNode, {y:'50%', autoAlpha:0})
        // TweenLite.to(this.$refs.menuNode, 1, {delay:0.2, y:'0%', autoAlpha:1, ease: Power4.easeOut})
        TweenLite.set(this.$refs.menuNode, {autoAlpha:0})
        TweenLite.to(this.$refs.menuNode, 1, {delay:0.3, autoAlpha:1})
        
        if (this.$router.currentRoute.name === 'Home') {
            // Animate text color
            for (i = 0; i < this.navigation.length; i++) {
                let nav = this.navigation[i]
                TweenLite.to(nav.node, 1, {delay: 0.4, color: this.navColor})
            }
        } else { // this.isActive !== true
            TweenLite.set(this.$refs.bgNode, {autoAlpha:1})
            
            TweenLite.set(this.$refs.burger, {delay: 1.2, autoAlpha:1})
            this.onHide(1.2)
        }
        
    },

    methods: {
        
        calculateNavSizes() {
            // Update current menu item & set animation varialbes
            this.liWidth = this.navItems[0].offsetWidth
            
            for (var i = 0; i < this.navigation.length; i++) {
                let nav = this.navigation[i]
                let li = this.navItems[i]
                let liWidth = li.offsetWidth
                let correction = (liWidth - nav.span.offsetWidth)

                nav.node = li
                nav.correction = correction
            }
        },
        
        setActiveNavItem() {

            // Update current menu item & set animation varialbes
            for (var i = 0; i < this.navigation.length; i++) {

                let nav = this.navigation[i]
                nav.node.classList.remove('active')

                if (nav.url === this.$router.currentRoute.path) {
                    this.activeId = i
                    this.currentPage = this.$router.currentRoute.name.toLowerCase()
                    this.navColor = this.navigation[i].textColor
                    nav.node.classList.add('active')
                }
            }
        },

        onMouseOver(index) {

            // Special case for 'Home'
            if (this.$router.currentRoute.name === 'Home' && this.isShowreelPlaying === false) {
                if (index === 0) {
                    let liNode = this.navItems[index]
                    let node = liNode.querySelector('.nav-link')
                    node.innerHTML = 'Play Showreel'
                }
                return
            }
        },

        onMouseLeave(index) {

            // Special case for 'Home'
            if (this.$router.currentRoute.name === 'Home' && this.isShowreelPlaying === false) {
                if (index === 0) {
                    let liNode = this.navItems[index]
                    let node = liNode.querySelector('.nav-link')
                    node.innerHTML = 'e-Types'
                }
                return
            }
        },

        onMouseClick(index, event) {

            // Special case for 'Home'
            if (this.$router.currentRoute.name === 'Home' && this.isShowreelPlaying === false) {

                if (index === 0) {
                    let liNode = this.navItems[index]
                    let node = liNode.querySelector('.nav-link')
                    node.innerHTML = 'e-Types'
                    
                    this.$store.dispatch('playShowreel')

                    event.preventDefault()
                    return
                }
            }
        },

        onCloseMenu(event) {
            event.preventDefault()
            if (this.$router.currentRoute.name !== 'Home') {
                this.onHide()
            }
        },

        setShow(setColor = true) {
            // console.log('set Show');
            var menuWidth = this.liWidth + (this.margin * 4) // double grid margin, both sides
            var distance = (menuWidth / 2) - (this.liWidth / 2)
            
            TweenLite.set(this.$refs.menuNode, {x: distance - this.margin, height: Size.height})

            for (var i = 0; i < this.navigation.length; i++) {
                let nav = this.navigation[i]
                if (i !== this.activeId || this.$router.currentRoute.name === 'Home') {
                    TweenLite.set(nav.node, {x: 0})
                    if (setColor === true) {
                        TweenLite.set(nav.node, {color: this.navColor})
                    }
                }
            }

            // this.showCloseBn = (this.$router.currentRoute.name === 'Home') ? false : true
            if (this.$router.currentRoute.name === 'Home') {
                TweenLite.set(this.$refs.closeNode, {autoAlpha:0})
            } else {
                TweenLite.set(this.$refs.closeNode, {autoAlpha:1})    
            }
            
            this.$refs.navNode.classList.add('open') // Add 'open' class to #navigation
            this.isActive = true

        },
        
        setHide() {
            
            // Remove classes from #navigation
            this.$refs.navNode.classList.remove('open')
            
            TweenLite.set(this.$refs.menuNode, {x: -(this.liWidth - this.peek)})
            for (var i = 0; i < this.navigation.length; i++) {
                let nav = this.navigation[i]
                
                TweenLite.set(nav.node, {x: nav.correction, color: this.navColor})
            }
            
            // this.showCloseBn = false
            TweenLite.set(this.$refs.closeNode, {autoAlpha:0})
        },

        // Animate SHOW
        onShow() {
            // console.log('onShow');
            
            let duration = 0.8
            let length = this.navigation.length
            let menuWidth = this.liWidth + (this.margin * 4) // double grid margin, both sides
            let distance = (menuWidth / 2) - (this.liWidth / 2)
            
            // Animate X-pos <nav>
            TweenLite.set(this.$refs.menuNode, {height: Size.height})
            TweenLite.to(this.$refs.menuNode, duration, {x: distance - this.margin, ease: Power4.easeOut})
            

            // Animate x-pos of each individual nav-item
            this.tlOpen = new TimelineLite({delay: 0, onComplete: this.onShowComplete})
            for (var i = 0; i < length; i++) {
                let nav = this.navigation[i]
                this.tlOpen.to(nav.node, duration, {x: 0, color: this.navColor, ease: Power2.easeOut}, 0)
            }
            
            
            // Background
            if (this.$router.currentRoute.name === 'Home') {
                TweenLite.to(this.$refs.bgNode, duration / 2, {autoAlpha: 0})
            } else {
                TweenLite.to(this.$refs.bgNode, duration / 2, {autoAlpha: 1})
            }
            
            // Burger - Mobile
            if (Size.width < 1024) {
                TweenLite.to(this.$refs.burgerBar1, 0.3, {rotation:45, width: '20px', top: '50%'})
                TweenLite.to(this.$refs.burgerBar2, 0.3, {rotation:-45, width: '20px', top: '50%'})
            }
            
            // Add 'open' class to #navigation
            this.$refs.navNode.classList.add('open')
            this.isActive = true
        },

        onShowComplete() {
            // this.showCloseBn = (this.$router.currentRoute.name === 'Home') ? false : true
            if (this.$router.currentRoute.name === 'Home') {
                TweenLite.set(this.$refs.closeNode, {autoAlpha:0})
            } else {
                TweenLite.set(this.$refs.closeNode, {autoAlpha:1})    
            }
        },

        // Animate HIDE
        onHide(delay = 0) {
            // console.log('onHide');
            
            let duration = 0.5
            
            // Kill open timeline - Make sure onComplete doesn't fire
            if (this.tlOpen) {
                this.tlOpen.kill()
            }
            
            var tl = new TimelineLite({delay: delay})
            let length = this.navigation.length

            for (var i = 0; i < length; i++) {
                let invertI = (length - i) - 1
                let nav = this.navigation[i]
                let time = (invertI * 0.1) + duration
                tl.to(nav.node, time, {x: nav.correction, color: this.navColor, ease: Power4.easeOut}, 0)
            }

            TweenLite.to(this.$refs.menuNode, duration, {delay: delay, x: -(this.liWidth - this.peek), ease: Power4.easeOut})
            TweenLite.to(this.$refs.bgNode, duration / 2, {delay: delay, autoAlpha: 0})
            
            // Burger - Mobile
            if (Size.width < 1024) {
                TweenLite.to(this.$refs.burgerBar1, 0.4, {rotation:0, width: '40px', top: '0%'})
                TweenLite.to(this.$refs.burgerBar2, 0.4, {rotation:0, width: '40px', top: '100%'})
            }
            
            // this.showCloseBn = false
            TweenLite.set(this.$refs.closeNode, {autoAlpha:0})
            
            // Remove 'open' class to #navigation
            this.$refs.navNode.classList.remove('open')
            this.isActive = false
        },


        onPopOut() {
            if (this.isActive === true) return
            
            TweenLite.to(this.$refs.menuNode, 0.4, {
                x: -(this.liWidth - (this.peek + this.hoverPeek)),
                ease: Power4.easeOut
            }, 0)
        },

        onPopIn() {
            if (this.isActive === true) return
            
            TweenLite.to(this.$refs.menuNode, 0.2, {
                x: -(this.liWidth - this.peek),
                ease: Power4.easeOut
            }, 0)
        },

        onResize() {
            
            this.peek = (Size.width < 1024) ? -10 : 32
            this.calculateNavSizes()
            
            if (this.isActive === false) {
                this.setHide()
            } else {
                this.setShow()
            }
        },
        
        isInternalLink(url) {
            return url.match(/^(http(s)?|ftp):\/\//) ? false : true
        },
        
    },

    watch: {
        $route() {
            
            this.setActiveNavItem()

            if (this.$router.currentRoute.name === 'Home') {
                this.onShow()
                
                
                TweenLite.set(this.$refs.closeNode, {autoAlpha:0})
                
                if (Size.width < 1024) {
                    // this.showCloseBn = false
                    TweenLite.set(this.$refs.closeNode, {autoAlpha:0})
                    TweenLite.set(this.$refs.burger, {autoAlpha:0})
                }
            } else {
                this.onHide()
                
                if (Size.width < 1024) {
                    TweenLite.set(this.$refs.burger, {autoAlpha:1})
                }
            }
        },
        isShowreelPlaying() {

            if (this.$router.currentRoute.name !== 'Home') return // Only effects landingpage
            
            if (this.isShowreelPlaying === true) {
                this.onHide()

            } else {
                this.onShow()
            }
        },
    },

    computed: {
        isShowreelPlaying() {
            return this.$store.state.isShowreelPlaying
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../scss/variables';
@import '../scss/font-scaling';

// .router-link-active {
//     border:1px solid blue; 
// }


#navigation {
    &.open {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    
    &.home {
        pointer-events: none;
    }
    
    .hit-area {
        position: fixed;
        top: 10px;
        left: 3%;
        width: 60px;
        height: 60px;
        pointer-events: auto;
        
        @media (min-width: $tablet) {
            left: 0;
            width: 62px; // 2/3 of 94px
            height: auto;
            top: 100px;
            bottom: 100px;
            cursor: pointer;
        }
    }
    
    .burger {
        position: fixed;
        pointer-events: none;
        
        left: 6%;
        top: 36px;
        height: 6px;
        width: 40px;
        
        .bar-1,
        .bar-2 {
            position: absolute;
            left: 0px;
            width: 100%;
            height: 1px;
            background: #000;
        }
        
        .bar-1 {
            top: 0;
        }
        .bar-2 {
            top: 100%;
        }
        
        @media (min-width: $tablet) {
            display: none;
        }
    }

    #primary-menu {
        position: fixed;
        display: flex;
        justify-content: center;
        flex-direction: column;
        top: 0;
        height: calc(100vh - 60px); // TODO - Set height with JS - window.innerHeight should be correct  // https://www.npmjs.com/package/ios-inner-height
        pointer-events: none;
  
        // @media (min-width: $tablet) {
        // }
        
        
        .nav-item {
            pointer-events: none;
            font-size: 12vw;
            line-height: 1em;
            
            @media (min-width: $tablet) {
                $offset-top: 100px;
                $offset-bottom: 100px;
                font-size: calc((100vh - #{$offset-top} - #{$offset-bottom}) / 6);
                line-height: 0.9em;
            }
            
            // // TODO - Active state
            // &.active {
            //     .nav-link {
            //         border-bottom: 1px solid;
            //         border-bottom-color: inherit;
            //     }
            // }

            span {
                display: inline-block;
                height: 100%;
                overflow: hidden;
                
                .nav-link {
                    position: relative;
                    display: block;

                    font-family: "Studio6";
                    color: inherit;
                    text-transform: uppercase;
                    pointer-events: auto;
                    
                    line-height: 0.9em;
                    margin-top: -0.1em;
                    
                    &.active {
                        // text-decoration: underline;
                        border-bottom: 1px solid;
                        border-bottom-color: inherit;
                    }
                }
            }
        }
    }
    
    // White milky BG
    .nav-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        visibility: hidden;
        pointer-events: initial;
        // background: linear-gradient(90deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.9));
        background: #fff;
    }

    .nav-close {
        position: fixed;
        top: 40px;
        right: 6%;
        width: calc(100% - 12%);
        text-align: right;
        
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.4s;
        
        
        @media (min-width: $tablet) {
            width: 94px;
            top: 0;
            height: 100%;
            right: 0;
            text-align: center;
        }

        .label {
            position: absolute;
            width: 100%;
            line-height: 0;
            
            @media (min-width: $tablet) {
                top: 50%;
                left: 50%;
                width: 100vh;
                transform: translate(-50%, -50%) rotate(90deg);
            }
            
            p {
                display: inline;
                
                color: inherit;
                font-size: 11px;
                color: inherit;
                text-transform: uppercase;
            
                @media (min-width: $tablet) {
                    @include FluidFontStart(1024, 1600, 12, 16);
                    @include FluidFontEndless(1600, 16, .4);
                }

                &.link {
                    cursor: pointer;

                    &:hover {
                        text-decoration: line-through;
                    }
                }
            }
        }
        
        .close-btn {
            display: none;
            
            @media (min-width: $tablet) {
                display: block;
                position: absolute;
                // width: 2vw;
                // max-width: 38px;
                // min-width: 24px;
                // height: 2vw;
                // top: 3vw;
                // right: 3vw;
                
                width: 20px;
                height: 20px;
                top: calc(40px - 4px); // Optical adjustment
                right: calc(94px/2);
                
                transform: translateX(50%);
                cursor: pointer;
            }
            
            .bar-1,
            .bar-2 {
                position: absolute;
                height: 1px;
                left: 0;
                width: 100%;
                top: 50%;
                background: #000;
            }
            
            .bar-1 {
                transform: rotate(45deg);
            }
            .bar-2 {
                transform: rotate(-45deg);
            }
        }
    }
}

// Play Variable font animation
// &.menu-open {
//     .nav-item {
//         .nav-link {
//             &:hover {
//                 font-variation-settings: "ital" 25;
//             }
// 
//         }
// 
//         &.active {
//             .nav-link {
//                 &:hover {
//                     font-variation-settings: "ital" 0;
//                 }
//             }
//         }
//     }
// }

// Play Variable font animation
// @keyframes italicIn {
//     0% {font-variation-settings: "ital" 0;}
//     50% {font-variation-settings: "ital" 32;}
//     100% {font-variation-settings: "ital" 0;}
// }
// @keyframes italicOut {
//     0% {font-variation-settings: "ital" 0;}
//     50% {font-variation-settings: "ital" -32;}
//     100% {font-variation-settings: "ital" 0;}
// }
// @keyframes italicOver {
//     0% {font-variation-settings: "ital" 0;}
//     100% {font-variation-settings: "ital" 32;}
// }

</style>
